module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result05-e1373e09d9e08da94f82496be0df9885.png";